import { oauthApi, walletApi } from "@/betby/api/services";
import type { OAuthLoginData, WalletBalanceData } from "@/betby/api/types";
import type { ApiResponse } from "@/betby/api";

export const authRepository = {
  login(
    sessionTicket: string,
    basic: Record<string, unknown>,
    options?: Record<string, unknown>,
  ) {
    const requestOptions = options ? { options } : undefined;
    return oauthApi.login(
      { session_ticket: sessionTicket, basic },
      requestOptions,
    );
  },
  refresh(refreshToken: string) {
    return oauthApi.refresh(refreshToken);
  },
  fetchBalance(options?: {
    skipErrorHandler?: boolean;
    headers?: Record<string, string>;
    options?: Record<string, unknown>;
  }): Promise<ApiResponse<WalletBalanceData>> {
    return walletApi.getBalance(options);
  },
};

export type AuthRepository = typeof authRepository;
export type LoginResponse = ApiResponse<OAuthLoginData>;
